// extracted by mini-css-extract-plugin
module.exports = {"title":"List_title__3ErRc","tabs":"List_tabs__38B2P"};